import React, { useState, useRef, useContext } from "react";
import { ChannelContext, RegionContext, PlayerContext } from "../contexts";
import "../assets/styles/region-switch.sass";
import Utility from "../Utility";
import { Link } from "react-router-dom";
import { text } from "../constants";
import useClickOutside from "../useClickOutside";

const RegionSwitch = ({ content }) => {
  const [listVisible, setListVisible] = useState(false);
  const { setUserIntent } = useContext(PlayerContext);
  const listRef = useRef(null);
  const switchButtonRef = useRef(null);
  useClickOutside([listRef, switchButtonRef], () => {
    if (listVisible) {
      setListVisible(false);
    }
  });

  const result = (
    <ChannelContext.Consumer>
      {(currentChannel) => {
        return (
          <RegionContext.Consumer>
            {(regionIndex) => {
              const channel = Utility.getChannel(content, currentChannel);
              const linksList = channel?.ether?.regions || [];
              if (!(linksList.length > 1)) {
                return null;
              }
              return (
                <div className="ur-mini-region-switch-wrapper">
                  <button
                    ref={switchButtonRef}
                    className={
                      "ur-mini-region-switch-button" +
                      (listVisible ? " ur-mini-regions-active" : "")
                    }
                    onClick={() => setListVisible(!listVisible)}
                  >
                    {text["Change region"]}
                  </button>
                  {listVisible ? (
                    <div className="ur-mini-regions-list" ref={listRef}>
                      {linksList.map((link, index) => (
                        <Link
                          key={index}
                          onClick={() => {
                            setListVisible(false);
                            setUserIntent();
                          }}
                          to={
                            channel.url
                              ? `/${channel.url}/${link.url}`
                              : `/${link.url}`
                          }
                          relative="path"
                          className={
                            "ur-mini-regions-list-item" +
                            (index === regionIndex
                              ? " ur-mini-regions-active"
                              : "")
                          }
                        >
                          {link.title}
                        </Link>
                      ))}
                    </div>
                  ) : null}
                </div>
              );
            }}
          </RegionContext.Consumer>
        );
      }}
    </ChannelContext.Consumer>
  );

  return result;
};

export default RegionSwitch;
